var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      { attrs: { viewBox: "0 0 1380 3800" } },
      [
        _c("scroll", {
          attrs: { speed: 1.5, responsive: true, "auto-play": "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var keyframe = ref.keyframe
                return [
                  _c(
                    "g",
                    [
                      _c("farm", {
                        attrs: {
                          color: "rgb(227,218,166)",
                          keyframe: keyframe,
                          y: 2500
                        }
                      }),
                      _c("ocean-scene", {
                        staticStyle: { fill: "#90CDF4" },
                        attrs: { "show-viewbox": false, keyframe: keyframe }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }